import { render, staticRenderFns } from "./taglar.vue?vue&type=template&id=1de6e644&"
import script from "./taglar.vue?vue&type=script&lang=js&"
export * from "./taglar.vue?vue&type=script&lang=js&"
import style0 from "./taglar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports